import ImageWithLoading from "@/components/image/image-with-loading";
import { cn } from "@/utils/cn";
import { memo, useEffect } from "react";

interface SwiperContentProps {
  id: string;
  name: string;
  imageUri: string;
  isActive: boolean;
  isNext: boolean;
  isPrev: boolean;
}

export const SwiperContent = memo(function SwiperContent({
  id,
  name,
  imageUri,
  isActive = false,
  isNext = false,
  isPrev = false,
}: SwiperContentProps) {
  useEffect(() => {
    if (!imageUri) {
      console.log("imageUri is empty", id, name, imageUri);
    }
  }, [imageUri, name, id]);

  return (
    <div className="h-full flex flex-col justify-end">
      <ImageWithLoading
        src={imageUri}
        alt={name}
        classNames={{
          container: cn(
            "w-32 h-32 rounded-full overflow-hidden border border-gray-100 p-1",
            "absolute transition-all duration-300",
            {
              "bottom-0 w-64 h-64 left-1/2 -translate-x-1/2": isActive,
              "top-0 translate-x-1/2": isNext,
              "top-0 -translate-x-1/2": isPrev,
            },
          ),
          image:
            "w-full h-full object-cover rounded-full border border-gray-100",
        }}
      />
    </div>
  );
});
